import styled from "@emotion/styled";
import React from "react";
import { excludePropsFromForwarding } from "../utils";

const FixedBannerContainer = styled(
  "div",
  excludePropsFromForwarding("hasSidebar")
)<{ hasSidebar: boolean }>`
  position: fixed;
  bottom: 32px;
  left: 0;
  right: 0;
  z-index: 100;
  display: flex;
  justify-content: center;
  padding: 0 16px;
  pointer-events: none;

  @media ${({ theme }) => theme.bp.tabletUp} {
    left: ${({ hasSidebar }) => (hasSidebar ? "208px" : "0")};
  }
`;

const Wrapper = styled.button`
  all: unset;
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 480px;
  max-width: 100%;
  background-color: ${({ theme }) => theme.colors.jungleLighter};
  border-radius: 100px;
  padding: 8px 8px 8px 32px;
  gap: 8px;
  box-shadow: 0px 8px 28px rgba(0, 0, 0, 0.22);
  transition: background-color 0.2s ease;
  pointer-events: auto;

  &:hover {
    background-color: ${({ theme }) => theme.colors.jungleLight};

    [data-pill-label] {
      background-color: ${({ theme }) => theme.colors.forestDark};
    }
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.forest};
    outline-offset: 2px;
  }

  @media ${({ theme }) => theme.bp.tabletDown} {
    padding: 8px 8px 8px 24px;
  }
`;

const QuestionText = styled.span`
  font-family: "Sofia Pro", sans-serif;
  font-weight: 700;
  font-size: 21px;
  line-height: 1.28;
  color: ${({ theme }) => theme.colors.forestDark};
  white-space: nowrap;

  @media ${({ theme }) => theme.bp.tabletDown} {
    font-size: 16px;
  }
`;

const PillLabel = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 14px 24px 14px 24px;
  background-color: ${({ theme }) => theme.colors.forest};
  color: ${({ theme }) => theme.colors.snowdrop};
  border-radius: 100px;
  font-family: "Sofia Pro", sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  transition: background-color 0.2s ease;
  white-space: nowrap;

  @media ${({ theme }) => theme.bp.tabletDown} {
    padding: 12px 20px;
    font-size: 14px;
  }
`;

type UnsureWhatToFundCardProps = {
  onClick: () => void;
  hasSidebar?: boolean;
};

export const UnsureWhatToFundCard = ({
  onClick,
  hasSidebar = false,
}: UnsureWhatToFundCardProps) => {
  return (
    <FixedBannerContainer hasSidebar={hasSidebar}>
      <Wrapper
        onClick={onClick}
        data-testid="unsure-what-to-fund-card"
        aria-label="Help me decide what to fund"
      >
        <QuestionText>Unsure what to fund?</QuestionText>
        <PillLabel data-pill-label aria-hidden="true">
          Help me decide
        </PillLabel>
      </Wrapper>
    </FixedBannerContainer>
  );
};
